(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/news/assets/news-article.js') >= 0) return;  svs.modules.push('/components/sportinfo/news/assets/news-article.js');
"use strict";


const {
  ReactIcon
} = svs.ui;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  detect
} = svs.core;
const NewsArticle = _ref => {
  let {
    author,
    headline,
    published,
    body
  } = _ref;
  if (detect.feature('ft-tipsen-new-news')) {
    return React.createElement("article", {
      className: "route-statistics-news-article route-statistics-news-article-new-design"
    }, React.createElement("h2", {
      className: "news-article-headline"
    }, headline), React.createElement("header", {
      className: "news-article-header"
    }, author && React.createElement("div", {
      className: "news-article-header-author news-article-header-item"
    }, author), React.createElement("div", {
      className: "news-article-header-published news-article-header-item"
    }, React.createElement("time", {
      dateTime: published
    }, formatDate(published, true, true, true)))), React.createElement("div", {
      className: "f-content",
      dangerouslySetInnerHTML: {
        __html: body
      }
    }));
  }
  return React.createElement("article", {
    className: "route-statistics-news-article"
  }, React.createElement("header", null, React.createElement("div", {
    className: "news-article-header-published"
  }, React.createElement(ReactIcon, {
    "aria-hidden": "true",
    color: "navy",
    icon: "clock-simple"
  }), React.createElement("time", {
    dateTime: published
  }, formatDate(published, true, true, true))), React.createElement("h2", {
    className: "news-article-headline"
  }, headline)), React.createElement("div", {
    className: "f-content",
    dangerouslySetInnerHTML: {
      __html: body
    }
  }));
};
setGlobal('svs.components.sportinfo.news.NewsArticle', NewsArticle);

 })(window);